<template>
<span>
  <a :class="['button', buttonClass || 'is-primary']" href="#_" v-on:click="activate">
    <slot></slot>
  </a>
  <b-modal
    v-model="active"
    has-modal-card
    trap-focus
    :destroy-on-hide="false"
    aria-role="dialog"
    aria-modal
  >
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">Add a Prospect</p>
        &nbsp;&nbsp;&nbsp;&nbsp;
        <button
          type="button"
          class="delete"
          v-on:click="close"/>
      </header>
      <div class="modal-card-body">
        <form method="POST" id="prospect-form" action="/advisordashboard/prospect-create/" ref="form" v-on:submit.prevent="submitForm">
          <div class="field">
            <label class="label" for="id_first_name">First name:</label>
            <div class="control is-expanded">
              <input class="input is-medium" type="text" name="first_name" maxlength="30" id="id_first_name">
              <div class="error" v-if="errors.first_name" v-for="error in errors.first_name">
                <p class="help is-danger">{{ error.message }}</p>
              </div>
            </div>
          </div>
          <div class="field">
            <label class="label" for="id_last_name">Last name:</label>
            <div class="control is-expanded">
              <input class="input is-medium" type="text" name="last_name" maxlength="150" id="id_last_name">
              <div class="error" v-if="errors.last_name" v-for="error in errors.last_name">
                <p class="help is-danger">{{ error.message }}</p>
              </div>
            </div>
          </div>
          <div class="field">
            <label class="label" for="id_email">Email address:</label>
            <div class="control is-expanded">
              <input class="input is-medium" type="email" name="email" maxlength="254" required="" id="id_email">
              <div class="error" v-if="errors.email">
                <p class="help is-danger">{{ errors.email[0].message }}</p>
              </div>
            </div>
          </div>
        </form>
      </div>
      <div class="modal-card-foot">
        <input
          type="submit"
          form="prospect-form"
          v-bind:value="buttonText"
          class="button is-primary is-right"
          ref="submitButton"
        />
      </div>
    </div>
  </b-modal>
</span>
</template>

<script>
  export default {
    data() {
      return {
        active: false,
        buttonText: 'Add Prospect',
        errors: {},
      }
    },
    props: {
      callback: Function,
      buttonClass: String,
    },
    methods: {
      reset() {
        this.buttonText = 'Add Prospect';
        ['first_name', 'last_name', 'email'].forEach(name => this.clearInput(name));
      },
      clearInput(name) {
        const input = document.getElementById('id_' + name);
        if(input) input.value = '';
      },
      close: function() {
        this.active = false;
      },
      activate: function() {
        this.active = true;
      },
      submitForm: function(evt) {
        var self = this;
        let form = this.$refs.form;
        this.buttonText = 'Saving...';
        const postData = new URLSearchParams(new FormData(form));
        fetch(form.action, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            'X-CSRFToken': this.$root.$data.csrfToken,
          },
          body: postData
        }).then((resp) => {
          if (resp.ok) {
            // this.callback.call(this, {...resp, ...Object.fromEntries(new URLSearchParams(postData)) });
            resp.json().then(data => {
              this.callback.call(this, { ...data, ...Object.fromEntries(new URLSearchParams(postData)) });
              this.close();
              this.reset();
            });
          }
          else {
            resp.json().then((data) => {
              this.buttonText = 'Add Prospect';
              self.errors = data.errors;
            })
          }
        });
      }
    },
  }

</script>
